<app-tab-layout [loading]="loading()" [error]="error">
  @if (initialized()) {
    <div class="planner-container">
      <div class="calendar-section">
        <app-calendar
          [markedDates]="calendarMarkedDates()"
          [loading]="calendarLoading()"
          (daySelected)="onDaySelected($event)"
          (monthChanged)="onMonthChanged($event)"
        />
      </div>

      @if (selectedDate()) {
        <div class="activities-section">
          @if (activitiesLoading()) {
            <div class="activities-grid">
              @for (i of [1, 2, 3, 4, 5, 6]; track i) {
                <div class="activity-card-skeleton">
                  <app-wiper-loading />
                </div>
              }
            </div>
          } @else if (activities().length > 0) {
            <div class="activities-grid">
              @for (activity of activities(); track $index) {
                <div class="activity-card">
                  <div class="activity-type-row">
                    <span class="work-type-badge {{ getWorkTypeClass(activity.workType) }}">{{ getWorkTypeLabel(activity.workType) }}</span>
                  </div>
                  <div class="activity-details">
                    @for (detail of getActivityDetails(activity); track detail.label) {
                      <div class="activity-detail">
                        <span class="activity-detail-label">{{ detail.label }}</span>
                        <span class="activity-detail-value">{{ detail.value }}</span>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          } @else {
            <div class="activities-empty">
              <span>{{ dictionaryService.get('NoDataAvailable') || 'No activities found' }}</span>
            </div>
          }
        </div>
      }
    </div>
  }
</app-tab-layout>
